import { render, staticRenderFns } from "./MainContactUs.vue?vue&type=template&id=408370a7&scoped=true&"
import script from "./MainContactUs.vue?vue&type=script&lang=js&"
export * from "./MainContactUs.vue?vue&type=script&lang=js&"
import style0 from "./MainContactUs.vue?vue&type=style&index=0&id=408370a7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408370a7",
  null
  
)

export default component.exports